/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmmaAccountSettings {
    angular.module("meevo.plugins.emmaAccountSettings", []);
}